// --------------------------------------------------------
// src/models/book.model.js
//
// Create and manage a Book Model object
//
// --------------------------------------------------------
"use strict";

const BookModel = Backbone.Model.extend({
    idAttribute: "book_id",
    // The default attributes, values of the book
    defaults: {
        audiobook: [],
        authors: [],
        book_id: null,
        citation: null,
        copyright: null,
        country: null,
        description: null,
        html: [],
        img: "./assets/images/error/default1.png",
        illustrators: [],
        language: [],
        narrator: null,
        nbPages: null,
        pdf: [],
        publisher: null,
        reading_level: null,
        theme: [],
        translator: null,
        title: null,
        type: "Fiction",
        year: null,
    },

    initialize: function() {
        const args = [].slice.call(arguments);

        if (args.length > 0) {
            this.attributes.format = [["PDF", "pdf"], ["Audio", "audiobook"], ["HTML", "html"]]
                .filter(format => Array.isArray(args[0][format[1]]) && args[0][format[1]].length > 0)
                .map(format => format[0]);
        } else {
            this.attributes.format = ["PDF", "Audio", "HTML"]
        }
    },

    // Return the first format that isn't empty
    // TODO: Handle the case where the returned value is ``undefined``
    getDefaultFormat: function () {
        let book = this.toJSON();

        return BookModel.getSupportedFormats().find(function (f) {
            return book.hasOwnProperty(f) && !_.objIsEmpty(book[f]);
        });
    },

    // Returns the default media link for the book
    getDefaultLink: function () {
        let format = this.getDefaultFormat();
        switch (format) {
            case "pdf":
                return "assets/pdf/" + this.getDefaultLanguage(format);
            case "audiobook":
                return "assets/audio/" + this.getDefaultLanguage(format);
            case "html":
                return this.getDefaultLanguage(format);
            default:
                return "book/" + this.get("id");
        }
    },

    // Return the link to a book in its default language
    getDefaultLanguage: function (attr) {
        var book = this.toJSON(),
            values = _.values(book[attr]),
            en_obj;

        en_obj = typeof _.findWhere(book[attr], {name: "English"}) !== "undefined" ?
            _.findWhere(book[attr], {fr_name: "Anglais"}) :
            _.findWhere(book[attr], {name: "English"});
        // The default language is english or the first language that isn't empty
        return typeof en_obj !== "undefined" ?
            en_obj.url.replace(/\\\/|\/\\/g, "/") :
            values[0].url.replace(/\\\/|\/\\/g, "/");
    },

    formatTitle: function (len) {
        var str = this.get("title");

        // Remove ", " and move "The" to the beginning of a string
        if (str.search(/, The/) !== -1) {
            str = str.replace(/, The/, "");
            str = str.replace(/^/, "The ");
        }

        // Slice titles if they are too long
        if (str.length > len) {
            str = str.slice(0, len);
            str += " ...";
        }

        return str;
    }

});

BookModel.format = function (str, len) {
    // Remove ", " and move "The" to the beginning of a string
    if (str.search(/, The/) !== -1) {
        str = str.replace(/, The/, "");
        str = str.replace(/^/, "The ");
    }

    // Slice titles if they are too long
    if (str.length > len) {
        str = str.slice(0, len);
        str += " ...";
    }

    return str;
};

/**
 * Return an BookModel representation of a record in the database
 *
 * @return BookModel
 * @param id
 */
BookModel.find = function (id) {
    // Create the BookModel object
    var bookModel = new BookModel();

    // Loop through every records in the database
    _.each(window.reads_data.book, function (book) {
        // If the record matches then copy its attributes into the BookModel object
        if (book.book_id === id) {
            bookModel.set({
                book_id: book.book_id,
                title: book.title,
                description: book.description,
                year: book.year,
                img: book.img,
                copyright: book.copyright,
                citation: book.citation,
                theme: book.theme,
                authors: book.authors,
                illustrators: book.illustrators,
                reading_level: book.reading_level,
                country: book.country,
                publisher: book.publisher,
                narrator: book.narrator,
                translator: book.translator,
                nbPages: book.translator,
                language: book.language,
                type: book.type,
                pdf: book.pdf,
                audiobook: book.audiobook,
                html: book.html
            });
        }
    });

    // Return the BookModel object
    return bookModel;
};

/**
 * Returns the list of supported formats for a book in Reads.
 *
 * @returns {string[]}
 */
BookModel.getSupportedFormats = function () {
    return ["pdf", "html", "audiobook"];
};